import { getSystem } from './appFunctions'

const setShareInfo = (url, imgUrl, title, desc) => {
  window.shareInfo = (type) => {
    /*
        type 分享类型:
        1 新浪微博
        2 腾讯微博(QQfriend)
        3 微信朋友圈
        4 微信好友
        */
    let text = ''
    switch (type) {
      case 1:
        // var text = `【${desc}】`;
        text = `@酒咔嚓 推荐「"${desc}"」，小伙伴们快行动，手慢无。`
        break
      case 2:
        text = `【${desc}】`
        break
      case 3:
        text = `【${desc}】${title}`
        break
      case 4:
        text = `【${desc}】`
        break
    }

    let content = imgUrl + '|' + text + '|' + url + '|' + title

    if (getSystem() == 'android') {
      if (type == 3) {
        content = imgUrl + '|' + title + '|' + url + '|' + text
      }
      window.kacha.invoke(1, type, content)
    } else {
      return content
    }
  }
}

export default setShareInfo



// WEBPACK FOOTER //
// ./src/utils/initAppShareInfo.js